import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import infoList from "@/mixins/infoList";
import { getGameCenterInfo, updateGameCenter } from "@/api/app";
import UploadImage from "@/components/upload/image.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "gameCenterConfig",
  mixins: [infoList],
  components: {
    UploadImage: UploadImage
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("app", ["selectAppId", "isAdd"])), {}, {
    showGameCategory: {
      get: function get() {
        if (this.form.show_game_category == "") {
          return [];
        }
        return this.form.show_game_category.split(",");
      },
      set: function set(arr) {
        this.form.show_game_category = arr.join(",");
      }
    }
  }),
  data: function data() {
    return {
      gameCategory: {
        1: "休闲",
        2: "网游"
      },
      form: {
        app_id: 0,
        game_center_url: "",
        title: "",
        banner_mode: "",
        is_show_online_game: "",
        is_show_online_game_ball: 1,
        is_show_gamecenter: 0,
        is_show_gamebar: 0,
        is_show_mobile_game: 1,
        is_show_game_album: 0,
        is_game_center_download: 0,
        game_center_download_title: 0,
        game_center_download_info: 0,
        game_center_icon: "",
        show_game_category: "1"
      }
    };
  },
  filters: {},
  methods: _objectSpread(_objectSpread({}, mapMutations("app", ["setSelectAppId", "setIsAdd"])), {}, {
    saveApp: function saveApp() {
      var _this = this;
      updateGameCenter(this.form).then(function (data) {
        _this.$message.success(data.msg);
      });
    },
    changeAppInfo: function changeAppInfo(AppId) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameCenterInfo({
                app_id: AppId
              });
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this2.setIsAdd(0);
                _this2.form = res.data.app;
              }
              _this2.$message.success(res.msg);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }),
  created: function created() {
    if (this.selectAppId != "") {
      this.changeAppInfo(this.selectAppId);
    }
  },
  watch: {
    // 监听computed中的属性
    selectAppId: function selectAppId(appId) {
      if (appId) {
        this.changeAppInfo(appId);
      }
    },
    isAdd: function isAdd(_isAdd) {
      if (_isAdd) {
        for (var key in this.form) {
          this.form[key] = "";
        }
      }
    }
  }
};